import { h } from 'preact';
import { Link } from 'preact-router/match';

const Header = () => (
	<header />
);

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js